module.exports = __webpack_public_path__ + "static/Ownership-a9e9243475f908440bdb9335a2de8ce6.svg";